// generated by svgr from images/icon-help-white.svg

import React from 'react'

const HelpIconWhite = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path fill="#fff" d="M8 0a8 8 0 000 16A8 8 0 008 0m0 1a7 7 0 11-.02 14.02A7 7 0 018 1m1 11a1 1 0 11-2 0 1 1 0 012 0m.97-8.36a2.33 2.33 0 00-.8-.48 3.15 3.15 0 00-1.7-.08 3.1 3.1 0 00-.64.22c-.19.09-.37.2-.53.31a3.8 3.8 0 00-.46.39l-.16.16.44.77c.15.3.45.46.82.17a3.13 3.13 0 01.63-.35c.23-.08.6-.12.9-.01a.92.92 0 01.3.17.7.7 0 01.18.25.8.8 0 01.06.33c0 .2-.03.37-.1.5-.1.16-.2.3-.31.43a2.99 2.99 0 01-.41.36 4.75 4.75 0 00-.47.4 1.96 1.96 0 00-.36.47c-.11.2-.15.79-.13 1.05l.11 1.3h1.3l.16-1.2c0-.07.04-.5.1-.57l.34-.31.45-.37a2.65 2.65 0 001-2.14c0-.36-.07-.7-.2-1a2.21 2.21 0 00-.52-.77z"/>
  </svg>
)

export default HelpIconWhite
